import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "";

// Separate no-retry client for FASTag calls.
// NEVER retry FASTag requests — each attempt burns quota and hits Masters India.
// If a call fails, show the error to the user; don't silently re-spend quota.
const fastagAxios = axios.create({ baseURL: BASE_URL, timeout: 20000 });

fastagAxios.interceptors.request.use(config => {
  const token = localStorage.getItem("trackin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

fastagAxios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("trackin_token");
      localStorage.removeItem("trackin_org");
      window.location.href = "/auth";
    }
    if (err.response?.status === 402 || err.response?.status === 403) {
      window.dispatchEvent(new CustomEvent("trackin:quota-sync"));
    }
    const msg = err.response?.data?.error || err.message || "Request failed";
    const error = new Error(msg);
    error.status = err.response?.status;
    error.quotaExhausted = err.response?.status === 402;
    error.suspended      = err.response?.data?.suspended === true;
    return Promise.reject(error);
  }
);

// FASTag API calls go through our backend (no retry — quota is precious).
// Credentials never appear in the browser bundle.
// Backend enforces quota and proxies to Masters India with its cached JWT.
export const fastagAPI = {
  post: (endpoint, body) => fastagAxios.post(`/api/fastag${endpoint}`, body),
};
